import React from "react";
import Cookies from "js-cookie";

import firebase from "js/firebase";
import * as analytics from "js/analytics";
import logger from "js/core/logger";

const FirebaseAuthContext = React.createContext();
export const FirebaseAuthConsumer = FirebaseAuthContext.Consumer;
export const TESTING_Provider = FirebaseAuthContext.Provider;

const log = logger.info(logger.AUTH).bind(logger);

export class FirebaseAuthProvider extends React.Component {
    constructor(props) {
        super(props);
        this.state = { didInit: false };
        this.auth = React.createRef(null);
    }

    componentDidMount() {
        const auth = this.props.auth || firebase.auth();
        this.auth.current = auth;

        log("Waiting for Firebase Auth to initalize");

        auth.onAuthStateChanged(user => {
            log("Firebase Auth state changed, user =", user ? user.toJSON() : null);
            if (user && user.isAnonymous || user && (user.email === undefined || user.email === null)) {
                // discard legacy anonymous users
                log("Signing out legacy anonymous Firebase Auth user");
                auth.signOut();
            } else {
                Cookies.set("logged-in", !!user);
                if (user) {
                    analytics.identify(user);
                }
                this.setState({ didInit: true });
            }
        });
    }

    render() {
        const { children } = this.props;
        return (
            <FirebaseAuthContext.Provider
                value={this.state.didInit ? this.auth.current : null}
            >
                {children}
            </FirebaseAuthContext.Provider>
        );
    }
}

/**
 * Workaround for ad-hoc ReactDOM.render trees within Backbone views,
 * which are unable to access the context tree. You *must* ensure that
 * there's an initalized FirebaseAuthProvider somewhere above this.
 */
export function UNSAFE_FirebaseAuthProvider({ children }) {
    return (
        <FirebaseAuthContext.Provider value={firebase.auth()}>
            { children }
        </FirebaseAuthContext.Provider>
    );
}

/**
 * HOC which injects `firebase.auth()` instance as `auth` prop. Very rarely needed!
 */
export function withFirebaseAuth(Component) {
    return function WithFirebaseAuth(props) {
        return (
            <FirebaseAuthContext.Consumer>
                {auth => <Component {...props} auth={auth} />}
            </FirebaseAuthContext.Consumer>
        );
    };
}
